import * as React from "react";
import {
    UitkLayoutFlex,
    UitkLayoutFlexItem,
    UitkPrimaryButton,
    UitkSecondaryButton,
    UitkPageLoader,
    UitkSpacing,
    UitkText
} from "@egencia/uitk-react";
import {useState} from "react";
import { logPanelBtnClickEvent } from "../common/omnitureLog.js";

export const PanelFooter = props => {
    const helpTitle = uitk.i18n.msg('need_help_title');
    const newContactChat = uitk.i18n.msg('new_contact_chat');
    const panelContactUsButton = uitk.i18n.msg('panel_contact_us_button');

    const chatbotEnabled = EG.bootstrapped.chatData?.chatBotOrCpEnabled ?? false;
    const panelViewName = props?.panelViewName ?? "DefaultPage";

    const shouldShowChatbotButton = chatbotEnabled && EG.analytics.configs["help-center.show_chatbot_button_in_panel_footer"].value;
    const shouldHideContactUs = EG.analytics.configs["help-center.panel.hide_contact_us_footer"].value;
    
    const [loading, setLoading] = useState(false);
    const onContactUsClick = e => {
        logPanelBtnClickEvent(panelViewName, '.ContactUs.Clicked');
        e.preventDefault();
        setLoading(true);
        window.location.href = !EG.user
            ? '/help-center/panel/call-us/anonymous'
            : '/help-center/panel/contact-options';
    };

    return (
        <div id="panel-footer" className={`footer ${shouldHideContactUs ? "visuallyhidden" : ""}`}>
            <UitkSpacing margin={{block:"two"}}>
                <UitkText weight="bold">{helpTitle}</UitkText>
            </UitkSpacing> 
            <UitkLayoutFlex direction="column" alignItems="stretch" space="three">
                <>
                    {shouldShowChatbotButton && (
                        <UitkLayoutFlexItem>
                            <UitkPrimaryButton className="chatbot-btn" data-panel-view-name={panelViewName} onClick={window.openChat}>
                                {newContactChat}
                            </UitkPrimaryButton>
                        </UitkLayoutFlexItem>
                    )}
                    <UitkSecondaryButton onClick={onContactUsClick}>
                        {panelContactUsButton}
                    </UitkSecondaryButton>
                </>
            </UitkLayoutFlex>
            <UitkPageLoader visible={loading} />
        </div>
    );
};